import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/assets/icon/services/services-consultorders.svg'


const _withScopeId = n => (_pushScopeId("data-v-e61006e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "text-white" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Serviços para seu MEI"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " Mantenha sua empresa regular com a ajuda de nossos serviços! ")
], -1))
const _hoisted_2 = { class: "flex flex-col bg-sky-50 rounded-t-xl relative mt-16" }
const _hoisted_3 = { style: {"margin-top":"-55px"} }
const _hoisted_4 = {
  key: 0,
  class: "py-10"
}
const _hoisted_5 = { class: "check-orders" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-16 h-10"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Consultar pedidos")
], -1))

import { computed, ref } from "vue";
import { IonPage, IonContent, onIonViewWillEnter } from "@ionic/vue";
import Header from "@/components/Header.vue";
import CardServices from "@/components/CardServices.vue";
import { useService } from "@/composables/services";
import { useIonRouter } from "@ionic/vue";
import Button from "@/components/base/Button.vue";
import { useUser } from "@/composables/user";
import LoadingScreen from "@/components/LoadingScreen.vue";
import { useOrderPayment } from "@/composables/orderPayment";


export default /*#__PURE__*/_defineComponent({
  __name: 'Services',
  setup(__props) {

const { loadUser, user } = useUser();
const { loadServices, services } = useService();
const { listOrderPayments, orderPayments } = useOrderPayment();
const ionRouter = useIonRouter();
const loading = ref<boolean>(true);
const handleGetServices = async (): Promise<any> => {
	await loadServices();
};

const pendingOrders = computed(() => {
	if (orderPayments.value)
		return orderPayments.value
			.filter((order: any) => !order.finishedAt)
			.map((order: any) => order.serviceCode);
	else return "";
});

const loadData = async () => {
	loading.value = true;
	await loadUser();
	await listOrderPayments();
	await handleGetServices();
	loading.value = false;
};

onIonViewWillEnter(() => {
	loadData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(LoadingScreen)
        ]),
        _: 1
      }, 512), [
        [_vShow, loading.value]
      ]),
      _withDirectives(_createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(Header, { class: "ion-no-border" }),
          _createElementVNode("main", null, [
            _hoisted_1,
            _createElementVNode("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (service) => {
                  return (_openBlock(), _createBlock(CardServices, {
                    key: service.id,
                    code: service.code,
                    name: service.name,
                    description: service.description,
                    amount: service.amount,
                    pending: _unref(pendingOrders)
                  }, null, 8, ["code", "name", "description", "amount", "pending"]))
                }), 128))
              ])
            ]),
            (_unref(user)?.activateService)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("section", _hoisted_5, [
                    _createVNode(Button, {
                      onClick: _cache[0] || (_cache[0] = () => _unref(ionRouter).push('/orders')),
                      class: "check-orders-btn"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, !loading.value]
      ])
    ]),
    _: 1
  }))
}
}

})